import React, { useRef, useState } from 'react';
import RecommendEmailList from '@domain/constant/RecommendEmailList';
import useClickAway from '@utils/hooks/useClickOutside';

const useRecommendEmailList = () => {
  const inputWrapRef = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false); // 리스트 출력 여부
  const [emailText, setEmailText] = useState<string>(''); // input 내 입력중인 이메일
  const [emailList, setEmailList] = useState(RecommendEmailList); //추천 이메일 리스트
  const [selected, setSelected] = useState(-1); //키보드 선택 index

  useClickAway(() => {
    if (isOpen) setIsOpen(false);
  }, inputWrapRef);

  const handleOnClickEmail = (first: string, second: string) => {
    const value = `${first.split('@')[0]}${second}`;
    setEmailText(value);
    setIsOpen(false);
    setSelected(-1);
  };

  const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!isOpen) return;
    if (e.key === 'ArrowDown') {
      // 리스트가 있을 때 input 내 커서 이동 방지
      e.preventDefault();
      if (selected + 1 > emailList.length - 1) return;
      setSelected(selected + 1);
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (selected - 1 < 0) return;
      setSelected(selected - 1);
    }

    if (e.key === 'Enter' && selected >= 0) {
      // form 에서 enter 시 submit 방지
      e.preventDefault();
      handleOnClickEmail(emailText, emailList[selected]);
    }
  };

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmailText(value);
    setSelected(-1);

    if (
      // 입력받은 문자열에서 @ 가 1개이고, @로 시작하지 않을 때 리스트 출력
      (value.match(/@/g) || []).length === 1 &&
      !value.startsWith('@')
    ) {
      setIsOpen(true);
      setEmailList(RecommendEmailList.filter((el) => el.startsWith(`@${value.split('@')[1]}`)));
    } else {
      setIsOpen(false);
    }
  };

  return {
    inputWrapRef,
    isOpen,
    emailText,
    emailList,
    selected,
    setSelected,
    handleOnKeyDown,
    handleOnClickEmail,
    handleOnChange,
  };
};

export default useRecommendEmailList;
